
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchInvoiceItems  , fetchInvoicesHeaders} from "../Api/VendorInvoice";
import "../Styling/PayrollTheme.css";

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "—";

  return Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const VIMInvoiceItems = () => {
  const { guid } = useParams();

  const [items, setItems] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInvoiceItems(guid)
      .then(setItems)
      .finally(() => setLoading(false));
  }, [guid]);

  if (loading) {
    return (
      <div className="pac-cockpit__loading">
        <span className="pac-cockpit__loading-dot" />
        <span className="pac-cockpit__loading-dot" />
        <span className="pac-cockpit__loading-dot" />
      </div>
    );
  }

  return (
    <div className="pac-cockpit__page">
      <div className="pac-cockpit__header">
        <h2 className="pac-cockpit__title">Invoice Item Details</h2>

        <p className="pac-cockpit__subtitle">
          Item details associated with selected invoice
        </p>
      </div>

      <div className="vim-table-card">
        <div className="vim-table-scroll">
          <table className="vim-table">
            <thead>
              <tr>
                <th>Description</th>
                <th>Product Code</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Amount</th>
                <th>Tax</th>
              </tr>
            </thead>

            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td colSpan={6} className="pac-grid__empty">
                    No items found
                  </td>
                </tr>
              ) : (
                items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.Description || "—"}</td>

                    <td>{item.ProductCode || "—"}</td>

                    <td>{item.Quantity ?? "—"}</td>

                    <td>{formatCurrency(item.UnitPrice)}</td>

                    <td>{formatCurrency(item.Amount)}</td>

                    <td>{formatCurrency(item.Tax)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VIMInvoiceItems;